import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { AuthServices } from './auth.services';
import { Observable} from 'rxjs/Observable';
import { CommonServices} from '../../services/src/api';
import {AppServices, MsgPopupService} from '../../services';

@Injectable()
export class ExtensionRsrcGuard implements CanActivate {
    constructor(private activeRoute: ActivatedRoute,
                private authService: AuthServices,
                private commonServices: CommonServices,
                private appServices: AppServices,
                private _msgPopupService: MsgPopupService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return true;
        /*const rsrcNo = JSON.parse(decodeURIComponent(route.params['option'])).extApplInstlNo;
        const curCmpnId = this.appServices.getCurCmpnId(route);

        return this.commonServices.getResourceAccessibleMap(curCmpnId, 'incident', rsrcNo)
            .map(_data => {
                const IF_ACCESSIBLE = _data > 0;
                // console.log('IF_ACCESSIBLE : ', IF_ACCESSIBLE);

                if (!IF_ACCESSIBLE) {
                    this._msgPopupService.msgEvent.emit({
                        'header_msg' : 'MK.01355',
                        'contents_msg' : 'MK.01356',
                        'close_btn_use_flag' : true});
                }

                return IF_ACCESSIBLE;
            });*/
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/authentications/src/extension-rsrc.guard.ts